var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view-legacyview"},[_c('Loading',{model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}}),_c('iframe',{attrs:{"id":"legacyFrame"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }